<template>
  <div>
    <h6>{{ $t("disposal-method.text") }}</h6>

    <LibraryItems
      rightPanelId="sidebar-new-data-disposal-method"
      organizationScopedState="dataDisposalMethod"
      libraryScopedState="disposalMethod"
      :hideCategoryFilter="true"
      :hideSaveAs="true"
      @interceptForSetParent="interceptForSetParent"
    />
  </div>
</template>

<script>
import LibraryItems from "@cc/library-items";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["dataDisposalMethod/isUpdating"];
    },
    //

    editedData() {
      return this.$store.getters["dataDisposalMethod/editedData"];
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.$store.dispatch("dataDisposalMethod/resetForm");
    },

    interceptForSetParent(payload) {
      payload.data = this.editedData;
    },
  },
};
</script>
